import SourceDefault from './source-default.svg';

// Google's favicon service. The Clearbit branch that used to sit here was
// removed: nothing selected it, and Clearbit's free logo API has been wound
// down, so it was a switchable provider that would have 404'd if anyone flipped
// REACT_APP_SOURCE_LOGO_PROVIDER.
export const logoProvider = 'https://s2.googleusercontent.com/s2/favicons?domain=';

// Without sz the service returns 16x16, which is a 3.75x upscale in a 30px
// tile on a 2x display - that is the whole of the blur. 128 is the useful
// ceiling: asking for 256 returns whatever the site actually publishes, which
// for some is smaller than 128, so the larger request buys nothing and makes
// the response size unpredictable.
export const LOGO_SIZE = 128;

const withSize = (url) => `${url}&sz=${LOGO_SIZE}`;

export function getLogo(option) {
  if (option.logo) {
    return option.logo;
  }

  if (!option.domain) {
    return SourceDefault;
  }

  if (option.domain === 'localhost:3000' || option.domain.includes('averpoint.com')) {
    return withSize(`${logoProvider}averpoint.com`);
  }

  return withSize(`${logoProvider}${option.domain}`);
}

// Fallback when a favicon 404s or decodes to nothing. Rendered as an SVG data
// URI rather than as a different element, so every existing rule that sizes,
// rounds or borders the <img> keeps applying - there are several, in different
// files, at different sizes.
//
// An unknown domain is a real case: the service answers 404 with a 16x16
// globe, and a broken-image glyph looks worse than any monogram.
const TILE_COLORS = ['#1286c8', '#0e6495', '#7e57c2', '#339900', '#e65100', '#65737b'];

export function letterTile(seed) {
  const text = (seed || '').trim();
  const letter = (text.charAt(0) || '?').toUpperCase();

  // Deterministic, so a source keeps the same colour between renders and
  // between sessions.
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash * 31 + text.charCodeAt(i)) % 100000;
  }
  const color = TILE_COLORS[hash % TILE_COLORS.length];

  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">` +
    `<rect width="128" height="128" fill="${color}"/>` +
    `<text x="64" y="64" fill="#ffffff" font-family="Open Sans, Helvetica, Arial, sans-serif" ` +
    `font-size="68" font-weight="600" text-anchor="middle" dominant-baseline="central">${letter}</text>` +
    `</svg>`;

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

// The letter comes from the domain rather than the source name: the name
// arrives from an async lookup and may not have landed when the image fails.
export function letterTileForUrl(url) {
  try {
    return letterTile(new URL(url).host.replace(/^www\./, ''));
  } catch (error) {
    return letterTile('');
  }
}
